var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocumentWithTail = function SvgDocumentWithTail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgDocumentWithTail",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgDocumentWithTail{fill:#b5b5b5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_7_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    className: "svgDocumentWithTail svgBase svgHover svgSelect",
    d: "M15.4,0.8h-9c-1,0-1.8,0.8-1.8,1.8V4h-2c-1,0-1.8,0.8-1.8,1.8v9.6c0,1,0.8,1.8,1.8,1.8h12.8 c1,0,1.8-0.8,1.8-1.8V2.6C17.2,1.6,16.4,0.8,15.4,0.8z M16.2,15.4c0,0.4-0.3,0.7-0.7,0.7h0H2.6c-0.4,0-0.7-0.3-0.7-0.7 c0,0,0,0,0,0V5.8C1.8,5.4,2.2,5,2.6,5h2v8.4c0,0.3,0.2,0.5,0.5,0.6c0.3,0,0.5-0.2,0.6-0.5c0,0,0,0,0,0V2.6c0-0.4,0.3-0.7,0.7-0.7 l0,0h9c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0V15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    className: "svgDocumentWithTail svgBase svgHover svgSelect",
    d: "M13.5,5.9H8.4c-0.3,0-0.5,0.3-0.5,0.6C7.9,6.7,8.1,7,8.4,7h5.1C13.8,7,14,6.7,14,6.4 C14,6.1,13.8,5.9,13.5,5.9L13.5,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    className: "svgDocumentWithTail svgBase svgHover svgSelect",
    d: "M13.5,11H8.4c-0.3,0-0.5,0.3-0.5,0.6c0,0.3,0.2,0.5,0.5,0.5h5.1c0.3,0,0.5-0.3,0.5-0.6 C14,11.3,13.8,11,13.5,11L13.5,11z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocumentWithTail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document_with_tail.96c81e65.svg";
export { ForwardRef as ReactComponent };